import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';

const MarkerWrapper = ({ style, children }) => (
  <div
    className="position-relative d-flex justify-content-center"
    style={{
      width:     '42px',
      height:    '42px',
      // Translate into this position in order to put marker wrapper
      // at the same position with google default marker
      transform: 'translate(-50%, -100%)',
      ...style }}
  >
    {children}
  </div>
);

export default MarkerWrapper;

MarkerWrapper.propTypes = {
  style:    PropTypes.shape(Object),
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.any.isRequired,
};

MarkerWrapper.defaultProps = {
  style: {},
};
